<template>
  <v-container fluid align-start ma-0 pa-2 class="epmsa210-main container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                  :useBtnList="[
                      'btnRetrieve', //Retrieve
                      'btnExcel'   //Save Excel
                    ]"
                  @btnRetrieve="btnRetrieve()"
                  @btnExcel="btnExcel()"
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2 pb-0">
                      <v-icon small color="blue">mdi-circle</v-icon>
                      <span class="pa-1 subTitle">Ship No. : </span>
                      <v-col cols="2">
                          <v-select
                            v-model="shipNo"
                            :items="shipNoList"
                            item-value="shipNo"
                            return-object
                            single-line
                            outlined
                            dense
                            label="Select"
                            @change="shipNoChange()"
                          ></v-select>
                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>
            
            <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epmsa210" 
                    class="hipGridHeight1_1" 
                    :ref="epmsa210Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }"
                  >
                    <DxEditing :use-icons="true" mode="cell" />
                    <DxColumn data-field="rnum" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="blockSeq" caption="Seq" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="block" caption="Block" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="mact" caption="M.Activity" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="bomSerno" caption="BOM SerNo" width="4%" data-type="string" alignment="center" header-cell-template="bomSerNoHeaderTemp" :allow-editing="false"/>
                          <template #bomSerNoHeaderTemp>
                            <div> BOM<br> SerNo.</div>
                          </template>
                    <DxColumn data-field="psdDte" caption="Mid P.S.D" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="pfdDte" caption="Mid P.F.D" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="cocw" caption="COCW" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="stageCd" caption="Stage" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="porNo" caption="POR No." width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="partNo" caption="Part No." width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="partSpec" caption="Specification" width="20%" data-type="string" alignment="left" :allow-editing="false"/>
                    <DxColumn data-field="partQty" caption="Qty" width="3%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                    <DxColumn data-field="matlUnit" caption="Unit" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="partUnitWgt" caption="Unit Weight" width="5%" data-type="string" alignment="right" header-cell-template="partUnitWgtHeaderTemp" :allow-editing="false"/>
                          <template #partUnitWgtHeaderTemp>
                            <div> Unit<br> Weight</div>
                          </template>
                    <DxColumn data-field="resDte" caption="Request Date" width="5%" data-type="string" alignment="center" header-cell-template="reqDteHeaderTemp" :allow-editing="false"/>
                    <template #reqDteHeaderTemp>
                      <div> Request<br>Date</div>
                    </template>

                    <DxColumn data-field="issueDte" caption="Carry Out Date" width="5%" data-type="string" alignment="center" header-cell-template="carryOutDteHeaderTemp" :allow-editing="false"/>
                    <template #carryOutDteHeaderTemp>
                      <div> Carry Out<br>Date</div>
                    </template>
                    <DxPaging :enabled="true" :page-size="60" />
                  </DxDataGrid>
                </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { epmsa210, epmsa210Xls } from '@/api/view/hip/A/epmsa210'
import { getShipNoList1} from '@/api/view/hip/common/common'
// import { reportView } from '@/api/view/hip/common/common'

export default {
  name: 'epmsa210',
  mixins: [baseview, BaseDataGrid],
  components: {
    
  },

  data() {
    return {
      menuTitle: this.$route.meta.title,
      useBtnList: ['btnRetrieve' ,'btnExcel'],
      epmsa210Ref: 'epmsa210Ref',
      gridMainList: [],
      shipNoList: [],
      makerCd: this.$store.state.user.makerCd,
      shipNo: ''

    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epmsa210Ref)
    },
  },
  mounted() {
    this.getList()
    //this.gridMainInstance.option('defaultPaging', false)
    //this.btnRetrieve()
  },
  methods: {
    async getList(){
      try {
        this.openLoading('searching')

        let param = {
          makerCd: this.$store.state.user.makerCd
        }
        await getShipNoList1(param).then(res => {
          this.shipNoList.push('')
          res.list.forEach(e => {
            this.shipNoList.push(e.shipNo)
          });
          this.shipNo = this.shipNoList[0] ;
        })
      } finally {
      this.endLoading()
      }
    },
    async getMainList(){
      try {
        this.openLoading('searching')
        let params = {
          shipNo : this.shipNo
        }
        await epmsa210(params).then(res => {
          let list = res.list
          let cnt = 1;
          let id = 0

          list.forEach(row => {
            id++
            row.id = id
          })
          
          //   list.push(
          //     {
          //       id: cnt++ , rnum: e.rnum, blockSeq: e.blockSeq,  block : e.block, mact : e.mAct,
          //       bomSerno: e.bomSerno, psdDte: e.psdDte, pfdDte: e.pfdDte,  cocw: e.cocw, 
          //       stageCd: e.stageCd, porNo: e.porNo + '-' + e.porSeq, partNo: e.partNo,  partSpec: e.partSpec, 
          //       partQty: e.partQty,  matlUnit: e.matlUnit, partUnitWgt: e.partUnitWgt,  
          //       resDte: e.resDte, issueDte: e.issueDte
          //     }
          //   )
          // });
          this.gridMainList = list
        })
      } finally {
      this.endLoading()
      }
    },
    shipNoChange(){
      this.btnRetrieve()
    },
    btnRetrieve(){
      this.gridMainList = []
      this.getMainList()
    },
    btnExcel(){
      this.openLoading('searching')
      const param = {
          shipNo: this.shipNo
      }
      epmsa210Xls(param)
      this.endLoading()
    },
  }
}
</script>
<style lang="scss" scoped>
.epmsa210-main {
  .subTitle {
    font-weight: bold;
    color: black;
  }

  ::v-deep.text__dely-no {
    input {
      text-align: center;
    }
  }
}
</style>